var map = {
	"./A.svg": 546,
	"./AccessAble-logo.png": 631,
	"./B.svg": 1455,
	"./PTSans-Bold.ttf": 8196,
	"./PTSans-BoldItalic.ttf": 668,
	"./PTSans-Italic.ttf": 6025,
	"./PTSans-Regular.ttf": 8978,
	"./PrayerAndReflectionLG.svg": 4581,
	"./UofG_App_Logo.svg": 5905,
	"./UofG_Life.png": 4246,
	"./af/individual_components.svg": 8676,
	"./af/s_graded.svg": 4064,
	"./af/s_notopen.svg": 7516,
	"./af/s_notsubmitted.svg": 8062,
	"./af/s_overdue.svg": 1755,
	"./af/s_submit.svg": 4166,
	"./af_course.svg": 3669,
	"./af_failure.svg": 1905,
	"./af_overdue.svg": 2281,
	"./af_submitted.svg": 7926,
	"./af_success.svg": 8783,
	"./apple-app-store-badge.svg": 8581,
	"./bell.svg": 2244,
	"./br_down.png": 3536,
	"./br_down.svg": 2517,
	"./br_up.png": 6737,
	"./br_up.svg": 7902,
	"./byod.png": 4270,
	"./capacity.svg": 8082,
	"./circle-tick.svg": 9668,
	"./cleanDeep.svg": 1747,
	"./cleanMaterials.svg": 6076,
	"./clearStar.png": 7815,
	"./club_img.svg": 9095,
	"./clubs/Academic.svg": 3077,
	"./clubs/Arts and Music.svg": 9768,
	"./clubs/Charity and Fundraising.svg": 1735,
	"./clubs/Crafts and Hobbies.svg": 702,
	"./clubs/Environment and Nature.svg": 9762,
	"./clubs/Faith.svg": 9497,
	"./clubs/Fiction and Fantasy.svg": 5447,
	"./clubs/Food and Drink.svg": 5815,
	"./clubs/Health and Wellbeing.svg": 1169,
	"./clubs/Languages and Culture.svg": 1947,
	"./clubs/Media and Broadcasting.svg": 3707,
	"./clubs/Other.svg": 4178,
	"./clubs/Political and Activism.svg": 480,
	"./clubs/Skills and Employability.svg": 3151,
	"./clubs/Sport.svg": 2297,
	"./clubs/Technology and Gaming.svg": 5615,
	"./clubs/defaultsport.png": 1762,
	"./deadlineIcon.png": 5688,
	"./defibrillatorLG.svg": 2202,
	"./desktop.png": 909,
	"./destination.png": 5231,
	"./error_24px_rounded.png": 5646,
	"./error_blue.svg": 9431,
	"./error_white.svg": 495,
	"./event_bg.svg": 5130,
	"./event_img.svg": 900,
	"./events-hmpg.svg": 2772,
	"./facemask.svg": 748,
	"./find-a-building-hmpg.svg": 7042,
	"./google-play-badge.png": 2249,
	"./gradeIcon.svg": 5985,
	"./greenTick.svg": 8021,
	"./group.png": 4925,
	"./group.svg": 4805,
	"./hw_counselling.svg": 1606,
	"./hw_counselling_bkgnd.jpg": 2732,
	"./hw_nightline.svg": 5764,
	"./hw_nightline_bkgnd.jpg": 1425,
	"./hw_reporting.svg": 7056,
	"./hw_togetherall.svg": 4879,
	"./hw_togetherall_bkgnd.jpg": 4994,
	"./hw_wellbeing.svg": 6806,
	"./hw_wellbeing_lg_bkgnd.svg": 9470,
	"./hw_wellbeing_sm_bkgnd.svg": 4463,
	"./index/deadline.svg": 7718,
	"./index/deadlines_grades.svg": 6905,
	"./index/expandChev.svg": 2053,
	"./index/hp_ass_feed.svg": 5829,
	"./index/hp_moodle.svg": 790,
	"./index/hp_timetable.svg": 2259,
	"./index/link_booking.svg": 7002,
	"./index/location_details.svg": 3687,
	"./index/location_details_solid.svg": 2582,
	"./index/main_logo.png": 3471,
	"./index/moodle.svg": 2649,
	"./index/on_campus.svg": 4487,
	"./index/online_live.svg": 46,
	"./index/recorded.svg": 8008,
	"./index/room_booking.svg": 1768,
	"./index/see_moodle.svg": 2671,
	"./individual.png": 8516,
	"./keydates/Academic.svg": 2989,
	"./keydates/Elections.svg": 4528,
	"./keydates/Enrolment.svg": 3459,
	"./keydates/Examination.svg": 9004,
	"./keydates/Graduation.svg": 8915,
	"./keydates/Revision.svg": 6580,
	"./keydates/Teaching.svg": 3884,
	"./keydates/Vacation.svg": 4807,
	"./library/available.png": 2199,
	"./library/overdue.png": 5457,
	"./location.png": 6780,
	"./logo-bg.png": 363,
	"./logo.gif": 918,
	"./logo.png": 6949,
	"./logo2.png": 1637,
	"./main_logo_uofglife.png": 5228,
	"./maintenance.svg": 9554,
	"./near-me-hmpg.svg": 8078,
	"./nearme/accessibleparking.png": 9388,
	"./nearme/accessibletoilet.png": 3987,
	"./nearme/atm.png": 5280,
	"./nearme/attraction.png": 614,
	"./nearme/babychanging.png": 131,
	"./nearme/bikerack.png": 8179,
	"./nearme/defibrillator.png": 5239,
	"./nearme/foodoutlet.png": 8178,
	"./nearme/offerholdersday.png": 1091,
	"./nearme/periodproduct.png": 277,
	"./nearme/prayerandreflection.png": 3878,
	"./nearme/repairs.png": 3118,
	"./nearme/retailoutlet.png": 4971,
	"./nearme/shower.png": 45,
	"./nearme/toilet.png": 7970,
	"./nearme/waterfountain.png": 7830,
	"./no_internet.svg": 7629,
	"./noti-bell.svg": 240,
	"./notif_bg.svg": 50,
	"./online.png": 2211,
	"./origin.png": 9561,
	"./period-productLG.svg": 574,
	"./rag-amber.svg": 7118,
	"./rag-green.svg": 1111,
	"./rag-red.svg": 6818,
	"./redCross.svg": 2165,
	"./retail-outletLG.svg": 390,
	"./room.png": 4401,
	"./schedule_24px.jpg": 9977,
	"./schedule_24px.png": 3103,
	"./social/facebook.svg": 4757,
	"./social/instagram.svg": 4512,
	"./social/twitter.svg": 7107,
	"./solid-burger-fries-slash.svg": 653,
	"./spaceindicator.png": 6331,
	"./spacelevels.png": 5800,
	"./style.scss": 3984,
	"./support-and-wellbeing-hmpg.svg": 5566,
	"./test.png": 2623,
	"./voteEnd.png": 1096,
	"./voteEnd.svg": 7794,
	"./voteStart.png": 408,
	"./voteStart.svg": 6083,
	"./voting-icon.svg": 2508,
	"./yellowStar.png": 7024
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;